/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/002-home2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 .5l-8 8L1.5 10 3 8.5V15h4v-3h2v3h4V8.5l1.5 1.5L16 8.5l-8-8zM8 7a1 1 0 110-2 1 1 0 010 2z"/>'
  }
})
